/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['underscore'], function (_) {
	'use strict';

	/**
  * The Class implements the root of class hierarchy implementing the mechanism for
  * creating new derived classes and calling inherited methods.
  */

	// @class
	// @abstract

	var Class = function Class() {};

	function createConstructor() {
		return function () {
			if (typeof this.init === 'function') {
				this.init.apply(this, arguments);
			}
		};
	}

	// Create new widget class derived from the Class
	// @static
	// @param mixins	[optional] An array of the mixin classes.
	// @param def		The definition of the derived class, methods, member variables. The
	//					special method 'init' is called at construction of the class instance.
	//
	Class.extend = function (mixins, def) {
		if (arguments.length === 1) {
			def = mixins;
			mixins = null;
		}

		var baseProto = this.prototype,
		    parentProto = baseProto,
		    proto = Object.create(parentProto);

		// create the constructor
		var ctor = createConstructor();

		// add the mixins
		if (mixins) {
			for (var i = 0, len = mixins.length; i < len; ++i) {
				proto = _.extend(proto, mixins[i].prototype);
			}
			parentProto = proto;
			proto = Object.create(proto);

			if (typeof def.init !== 'function') {
				// generate default init method for multi-class inheritance
				def.init = function () {
					ctor.inherited('init', this, arguments);
				};
			}
		}

		_.extend(proto, def);
		ctor.prototype = proto;

		// static method to allow for further extension
		ctor.extend = this.extend;

		// calling the inherited methods
		ctor.inherited = function (name, that, args) {
			if (name === 'init') {
				// the 'init' method has a special case of calling inherited implementation
				// it should call all the 'init' methods from the base class and mixins
				if (typeof baseProto[name] === 'function') {
					baseProto[name].apply(that, args);
				}
				_.each(mixins, function (m) {
					if (typeof m.prototype[name] === 'function') {
						m.prototype[name].apply(that, args);
					}
				});
			} else if (typeof parentProto[name] === 'function') {
				return parentProto[name].apply(that, args);
			}
		};

		return ctor;
	};

	return Class;
});
//# sourceMappingURL=Class.js.map



// WEBPACK FOOTER //
// ./src/js/lib/@waca/core-client/js/core-client/ui/core/Class.js